export const BRAND = {
  name: "Delhigence.AI",
  positioning: "Applied AI for operational workflows",
  logo: "https://customer-assets.emergentagent.com/job_emergent-finance-7/artifacts/oaot72e7_deligence%20bg%20rm.png",
  partners: [
    {
      name: "Shark Tank India",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_emergent-finance-7/artifacts/ldo9wzvq_images%20%283%29.jpeg",
    },
    {
      name: "Madhya Pradesh League",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_emergent-finance-7/artifacts/wrisozth_mpl-logo.png",
    },
    { name: "Underneat", src: "" },
    {
      name: "Beast Life",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_emergent-finance-7/artifacts/qpvydfv2_images%20%283%29.png",
    },
    { name: "Off/Beat", src: "" },
    { name: "Rosier Foods", src: "" },
    {
      name: "MPCA",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_emergent-finance-7/artifacts/1a8nuw3c_images%20%284%29.jpeg",
    },
    {
      name: "State Bank of India",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_emergent-finance-7/artifacts/ez2ggesr_11bdcdf25fad9a03dbf803d1a6b38e97.jpg",
    },
    {
      name: "Punjab National Bank",
      src: "https://customer-assets-v7afamib.emergentagent.net/job_emergent-finance-7/artifacts/afbu7ni7_punjab-national-bank-pnb-bank-logo-free-free-vector.jpg",
    },
    {
      name: "J&K Bank",
      src: "https://upload.wikimedia.org/wikipedia/en/thumb/e/e8/Jammu_and_Kashmir_Bank_Logo.png/220px-Jammu_and_Kashmir_Bank_Logo.png",
    },
    {
      name: "Punjab & Sind Bank",
      src: "https://upload.wikimedia.org/wikipedia/en/thumb/1/17/Punjab_%26_Sind_Bank.svg/1200px-Punjab_%26_Sind_Bank.svg.png",
    },
    {
      name: "Adani Airports",
      src: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/Adani_2012_logo.png/1200px-Adani_2012_logo.png",
    },
  ],
  email: "hello@delhigence.ai",
  social: {
    linkedin: "https://www.linkedin.com",
    x: "https://x.com",
  },
};
